import { IS_WEB } from "@common/utils/mobileUtils"
import Constants from "expo-constants"

export const apiConstants = {
    _IDLE: "_IDLE",
    _REQUEST: "_REQUEST",
    _SUCCESS: "_SUCCESS",
    _FAILURE: "_FAILURE",
    NETWORK_ON: "NETWORK_ON",
    NETWORK_OFF: "NETWORK_OFF",
}

const API_URLS = {
    integration: "https://api-integration.masteur.com",
    staging: "https://api-staging.masteur.com",
    production: "https://api.masteur.com",
} // when modifying here for server environments, you must also modify same const in app.config.js

export const VAPOR_FILE_UPLOAD = "VAPOR_FILE_UPLOAD"

// Dev API URLs: all configurable via .env.local (gitignored).
// Set EXPO_PUBLIC_DEV_SERVER to a remote env name (integration, staging)
// to bypass local URLs entirely.
const devServer = process.env.EXPO_PUBLIC_DEV_SERVER || ""
const apiURLWeb =
    process.env.EXPO_PUBLIC_DEV_API_URL_WEB || "https://api.masteur.test"
const apiURLMobile =
    process.env.EXPO_PUBLIC_DEV_API_URL || "http://localhost:8000"

export const API_URL = __DEV__
    ? API_URLS[devServer]
        ? API_URLS[devServer]
        : IS_WEB
          ? apiURLWeb
          : apiURLMobile
    : Constants.expoConfig.extra.apiUrl

export const APP_URLS = {
    development: "https://app.masteur.test",
    integration: "https://app-integration.masteur.com",
    staging: "https://app-staging.masteur.com",
    production: "https://app.masteur.com",
} // when modifying here for server environments, you must also modify same const in app.config.js

export const APP_URL = __DEV__
    ? APP_URLS[devServer]
        ? APP_URLS[devServer]
        : IS_WEB
          ? "https://app.masteur.test"
          : APP_URLS.development
    : Constants.expoConfig.extra.appUrl

const BO_URLS = {
    development: "http://localhost:5173",
    integration: "https://bo-staging.masteur.com",
    staging: "https://bo-staging.masteur.com",
    production: "https://bo.masteur.com",
} // when modifying here for server environments, you must also modify same const in app.config.js

export const BO_URL = __DEV__
    ? (BO_URLS[devServer] ?? BO_URLS.development)
    : (Constants.expoConfig?.extra?.boUrl ?? BO_URLS.production)

const STRIPE_PUBLISHABLE_KEYS = {
    development:
        "pk_test_51KdzqAKmdIPY1QCMfXxh8v8T55j8YQkLcZMC6VkLFQUK0qlN8NkJ7vdLEtL7u6xP6LuDd2P06CXQczymZKwm0FEL00dyQovkRW",
    integration:
        "pk_test_51KdzqAKmdIPY1QCMfXxh8v8T55j8YQkLcZMC6VkLFQUK0qlN8NkJ7vdLEtL7u6xP6LuDd2P06CXQczymZKwm0FEL00dyQovkRW",
    staging:
        "pk_test_51KdzqAKmdIPY1QCMfXxh8v8T55j8YQkLcZMC6VkLFQUK0qlN8NkJ7vdLEtL7u6xP6LuDd2P06CXQczymZKwm0FEL00dyQovkRW",
    production:
        "pk_live_51KdzqAKmdIPY1QCMkPFFtZ78IIxi88OOVxAohHhIqemdphoZsNeWOl41DXZeIG52GefOSY8PCW4U9ia7TBta3YU200ziwHLSfB",
} // when modifying here, you must also modify same const in app.config.js

export const STRIPE_PUBLISHABLE_KEY = __DEV__
    ? STRIPE_PUBLISHABLE_KEYS[devServer]
        ? STRIPE_PUBLISHABLE_KEYS[devServer]
        : STRIPE_PUBLISHABLE_KEYS.development
    : (Constants.expoConfig?.extra?.stripePublishableKey ??
      STRIPE_PUBLISHABLE_KEYS.production)

export const cleanMediaUrl = (mediaUrl) =>
    mediaUrl?.replace("https://api.masteur.test", API_URL) ?? null
